exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".stepper__step{padding:24px 24px 26px!important}.stepper__step--active div{font-size:18px}.stepper__label{font-size:16px}.stepper__label small{font-size:13px}.stepper__content{padding:0 22px 0 8px!important;margin-bottom:8px!important}.stepper .description-text{font-size:16px;line-height:30px;margin-top:0}.stepper__step__step{height:50px;width:50px}.stepper__step__step i{font-size:35px!important}@media only screen and (max-width:500px){.stepper__step{padding:24px 0 6px 6px!important}.stepper__content{padding:0!important;margin:10px!important}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-634d2da7","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/StepList.vue
// module id = 409
// module chunks = 0